import styled from "styled-components";

const Clickable = styled.div`
	display: flex;
	cursor: pointer;
`;

export default Clickable;
